import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Toolbar,
  Menu,
  MenuItem,
} from '@material-ui/core';

import './centraltoolbar.scss';
import { SwitchBrightnessDialog, SwitchProgramDialog, SwitchOperatingModeDialog,
   ShowEnergyDataDialog, ShowMobileStateDialog } from './dialogs';

const useStyles = makeStyles(() => ({
  root: {},
}));

const CentralToolbar = props => {
  const { source, ...rest } = props;

  const classes = useStyles();

  return (
    <div
      {...rest}
      className={classes.root}
    >
      <Toolbar className="plan-toolbar">
        <SwitchOrderMenu source={source}/>
        <DisplayStateMenu source={source}/>
      </Toolbar>
    </div>
  );
};


const SwitchOrderMenu = props => {
  const { source } = props;
  const [openSwitchProgramDialog, setOpenSwitchProgramDialog] = useState(false);
  const [openSwitchOperatingModeDialog, setOpenSwitchOperatingModeDialog] = useState(false);
  const [openSwitchBrightnessDialog, setOpenSwitchBrightnessDialog] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleSwitchProgramDialogOpen = () => {
    setAnchorEl(null);
    setOpenSwitchProgramDialog(true);
  };

  const handleSwitchOperatingModeDialogOpen = () => {
    setAnchorEl(null);
    setOpenSwitchOperatingModeDialog(true);
  };

  const handleSwitchBrightnessDialogOpen = () => {
    setAnchorEl(null);
    setOpenSwitchBrightnessDialog(true);
  };

  function handleMenuClick(event) {
    setAnchorEl(event.currentTarget);
  }
  
  function handleMenuClose() {
    setAnchorEl(null);
  }

  const handleVerifyClicked = () => {
    setOpenSwitchProgramDialog(false);
    setOpenSwitchOperatingModeDialog(false);
    setOpenSwitchBrightnessDialog(false);
  };

  const handleDialogClose = () => {
    setOpenSwitchProgramDialog(false);
    setOpenSwitchOperatingModeDialog(false);
    setOpenSwitchBrightnessDialog(false);
  };

  return (
    <>
        {openSwitchProgramDialog && <SwitchProgramDialog source={source} open={openSwitchProgramDialog} onVerifyClick={handleVerifyClicked} onClose={handleDialogClose} />}
        {openSwitchOperatingModeDialog && <SwitchOperatingModeDialog source={source} open={openSwitchOperatingModeDialog} onVerifyClick={handleVerifyClicked} onClose={handleDialogClose} />}
        {openSwitchBrightnessDialog && <SwitchBrightnessDialog source={source} open={openSwitchBrightnessDialog} onVerifyClick={handleVerifyClicked} onClose={handleDialogClose} />}
        <Button color="inherit" onClick={handleMenuClick}>
          Schalten
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleSwitchProgramDialogOpen}>Programm</MenuItem>
          <MenuItem onClick={handleSwitchOperatingModeDialogOpen}>Betriebsart</MenuItem>
          <MenuItem onClick={handleSwitchBrightnessDialogOpen}>Helligkeit</MenuItem>
        </Menu>
    </>
  );
};


const DisplayStateMenu = props => {
  const { source } = props;
  const [openEnergyDataDialog, setOpenEnergyDataDialog] = useState(false);
  const [openMobileStateDialog, setOpenMobileStateDialog] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleEnergyDataDialogOpen = () => {
    setAnchorEl(null);
    setOpenEnergyDataDialog(true);
  };

  const handleMobileStateDialogOpen = () => {
    setAnchorEl(null);
    setOpenMobileStateDialog(true);
  };

  function handleMenuClick(event) {
    setAnchorEl(event.currentTarget);
  }
  
  function handleMenuClose() {
    setAnchorEl(null);
  }

  const handleVerifyClicked = () => {
    setOpenEnergyDataDialog(false);
    setOpenMobileStateDialog(false);
  };

  const handleDialogClose = () => {
    setOpenEnergyDataDialog(false);
    setOpenMobileStateDialog(false);
  };

  return (
    <>
        {openEnergyDataDialog && <ShowEnergyDataDialog source={source} open={openEnergyDataDialog} onVerifyClick={handleVerifyClicked} onClose={handleDialogClose} />}
        {openMobileStateDialog && <ShowMobileStateDialog source={source} open={openMobileStateDialog} onVerifyClick={handleVerifyClicked} onClose={handleDialogClose} />}
        <Button color="inherit" onClick={handleMenuClick}>
          Anzeige
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleEnergyDataDialogOpen}>Energiestatus</MenuItem>
          <MenuItem onClick={handleMobileStateDialogOpen}>Mobilfunkstatus</MenuItem>
        </Menu>
    </>
  );
};

CentralToolbar.propTypes = {
  source: PropTypes.object.isRequired
};

export default CentralToolbar;
